import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
const ToastContext = createContext(undefined);
let globalToastCounter = 0;
export function ToastProvider({
  children
}) {
  const [toasts, setToasts] = useState([]);
  const [headerMode, setHeaderMode] = useState(false);
  const headerModeRef = useRef(false);
  const [latestToast, setLatestToast] = useState(null);
  const timeoutsRef = useRef(new Map());
  const removeToast = useCallback(id => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
    const timeout = timeoutsRef.current.get(id);
    if (timeout) {
      clearTimeout(timeout);
      timeoutsRef.current.delete(id);
    }
  }, []);
  const addToast = useCallback((type, message, duration = 4000) => {
    const id_0 = `toast-${Date.now()}-${globalToastCounter++}`;
    const newToast = {
      id: id_0,
      type,
      message,
      duration,
      createdAt: Date.now()
    };
    if (headerModeRef.current) {
      setLatestToast(newToast);
      if (duration > 0) {
        const timeout_0 = setTimeout(() => {
          setLatestToast(null);
        }, duration);
        timeoutsRef.current.set(id_0, timeout_0);
      }
    } else {
      setToasts(prev_0 => [...prev_0, newToast]);
      if (duration > 0) {
        const timeout_1 = setTimeout(() => {
          removeToast(id_0);
        }, duration);
        timeoutsRef.current.set(id_0, timeout_1);
      }
    }
    return id_0;
  }, [removeToast]);
  const clearAll = useCallback(() => {
    timeoutsRef.current.forEach(timeout_2 => clearTimeout(timeout_2));
    timeoutsRef.current.clear();
    setToasts([]);
  }, []);
  const setHeaderModeCallback = useCallback(enabled => {
    setHeaderMode(enabled);
    headerModeRef.current = enabled;
    if (!enabled) {
      setLatestToast(null);
      timeoutsRef.current.forEach(timeout_3 => clearTimeout(timeout_3));
      timeoutsRef.current.clear();
    }
  }, []);
  // Cleanup on unmount
  useEffect(() => {
    const timeouts = timeoutsRef.current;
    return () => {
      timeouts.forEach(timeout_4 => clearTimeout(timeout_4));
      timeouts.clear();
    };
  }, []);
  return _jsx(ToastContext.Provider, {
    value: {
      toasts,
      addToast,
      removeToast,
      clearAll,
      headerMode,
      setHeaderMode: setHeaderModeCallback,
      latestToast
    },
    children: children
  });
}
export function useToastContext() {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToastContext must be used within ToastProvider");
  }
  return context;
}